module.exports = __webpack_public_path__ + "static/media/onda-violeta2.9ca449a1.png";